import { Avatar, Button, Modal } from 'antd'
import React, { useState } from 'react'

function WinnerListModal({ winnerModal, handleCancel, winnerList, loader, handleSubmit }) {
    console.log(winnerList);

    const [winnerData, setWinnerData] = useState(null)
    console.log(winnerData);

    const handleSelect = (item, index) => {
        const skipElements = winnerList.slice(-(index + 1)).map(user => user?.userID?._id);
        setWinnerData(
            {
                buyerID: item?.userID?._id,

                skipElements: skipElements
            }
        )

    }
    const lastTwoElements = winnerList?.length >= 2 ? winnerList?.slice(-2).reverse() : winnerList;
    return (
        <div>


            <Modal
                open={winnerModal}
                onCancel={handleCancel}
                footer={null}
                title='Winner List'
            >
                {lastTwoElements?.map((item, index) => (
                    <div key={index} className={`${winnerData?.buyerID === item?.userID?._id ? 'border-green-500 shadow-md' : ""} flex justify-between border border-solid p-3 items-center mt-4  rounded-md`}>

                        <div className='flex gap-2 items-center'>

                            <Avatar />

                            <div>
                                <p>{item.userID.name}</p>
                                <p className=''> Rank {index + 1}</p>
                            </div>

                        </div>
{item.status==='accepted'?<p className='text-green-500'>Ready to buy</p>:item.status==='rejected'?<p className='text-red-500'>Not Ready to Buy</p>:""}
                        {winnerData?.buyerID === item?.userID?._id ? <Button onClick={() => { setWinnerData(null) }}>Remove</Button>
                            : <Button className='px-6' onClick={() => handleSelect(item, index)} disabled={item.status==='rejected'}>Select</Button>}
                    </div>
                ))}
                <div className="flex justify-end mt-6">
                    <Button onClick={handleCancel} className="py-3 px-6 mr-4 font-semibold">
                        Dismiss
                    </Button>
                    <Button disabled={!winnerData} onClick={() => { handleSubmit(winnerData) }} loading={loader} className="bg-blue-500 py-3 px-6 text-white font-medium">
                        Submit
                    </Button>
                </div>
            </Modal >
        </div>
    )
}

export default WinnerListModal